import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { CheckboxComponent } from "../../components/CustomFormElement";
import { SwithOffIcon, SwithOnIcon } from "../../components/CustomIcons";
import CustomSection from "../../components/CustomSection";
import theme from '../../theme.css';
import CardsController from "./CardsController";
import CardsView from "./CardsView";
import ChangePasswordView from "./ChangePasswordView";
import ContactInformationView from "./ContactInformationView";
import HomeAddressView from './HomeAddressView';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2)
    },
    content: {
        background: theme.palette.common.white,
        padding: theme.spacing(1),
        height: '100%'
    },
    email: {
        cursor: 'pointer'
    },
    sms: {
        // marginTop: theme.spacing(4),
        cursor: 'pointer'
    },
}));

export default function SettingView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { contactInfo, onSaveContactInfo, onSaveHomeAddress, contactLoading, cardsLoading, files, onHandleBlur } = props;

    return (
        <Grid item xs={12} className={classes.main}>
            <Grid item xs={12} container direction='row' spacing={1}>
                <Grid item xs={12} md={6}>
                    <Grid item xs={12} className={classes.content}>
                        <ContactInformationView
                            contactInfo={contactInfo}
                            contactLoading={contactLoading}
                            files={files}
                            showLoadingEmail={props.showLoadingEmail}
                            validations={props.validations}
                            attachments={props.attachments}
                            avatar={props.avatar}
                            isSendDirectSale={props.isSendDirectSale}
                            isSendAffiliate={props.isSendAffiliate}
                            onSendDirectSale={props.onSendDirectSale}
                            onSendAffiliate={props.onSendAffiliate}
                            onSaveContactInfo={onSaveContactInfo}
                            onAddImage={props.onAddImage}
                            onOpenFile={props.onOpenFile}
                            onHandleBlur={onHandleBlur}
                            onCheckEmail={props.onCheckEmail}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid item xs={12} className={classes.content}>
                        <HomeAddressView
                            contactInfo={contactInfo}
                            addressLoading={props.addressLoading}
                            addressHome={props.addressHome}
                            onSaveHomeAddress={onSaveHomeAddress}
                        />
                        <Grid item xs={12} className={classes.content}>
                            <MarketingPreferences
                                t={t}
                                classes={classes}
                                showLoading={props.showLoading}
                                email_opt_out={props.email_opt_out}
                                sms_opt_out={props.sms_opt_out}
                                onUpdateMarketingInformation={props.onUpdateMarketingInformation}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} container direction='row' spacing={1} marginTop={1}>
                <Grid item xs={12} md={6}>
                    <Grid item xs={12} className={classes.content}>
                        <CardsController/>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid item xs={12} className={classes.content}>
                        <ChangePasswordView
                            showFormChangePass={props.showFormChangePass}
                            onChangePassword={props.onChangePassword}
                            setShowFormChangePass={props.setShowFormChangePass}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function MarketingPreferences(props) {
    const { t, classes, showLoading, email_opt_out, sms_opt_out, onUpdateMarketingInformation } = props;
    console.log("props MarketingPreferences===", props);

    return (
        <CustomSection notMarginTop={true} title={t('marketing_preferences')}>
            <Grid item xs={12}>
                <Grid item xs={12} md={6} container className={classes.email} onClick={() => onUpdateMarketingInformation('email_opt_out', !email_opt_out)}>
                    <Grid xs={10} item container justify='flex-start'>
                        <Typography>{t('setting_email')}</Typography>
                    </Grid>
                    <Grid xs={2} item container justify='flex-end'>
                        {showLoading ? <CustomCircularProgress /> : (email_opt_out ? <SwithOnIcon /> : <SwithOffIcon />)}
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6} container className={classes.sms} onClick={() => onUpdateMarketingInformation('sms_opt_out', !sms_opt_out)}>
                    <Grid xs={10} item container justify='flex-start'>
                        <Typography>{t('setting_sms')}</Typography>
                    </Grid>
                    <Grid xs={2} item container justify='flex-end'>
                        {showLoading ? <CustomCircularProgress /> : (sms_opt_out ? <SwithOnIcon /> : <SwithOffIcon />)}
                    </Grid>
                </Grid>
            </Grid>
        </CustomSection>
    )
}